import { State, Selector, Action, StateContext } from '@ngxs/store';
import { TblBidDataDisplay } from '../../models/TblBidDataDisplay';
import {
  AddCurrentBidData,
  RemoveCurrentBidData,
} from '../actions/CurrentBidData.action';

export class CurrentBidDataStateModel {
  currentBidData: TblBidDataDisplay;
}

@State({
  name: 'currentBidData',
  defaults: {
    currentBidData: undefined,
  },
})
export class CurrentBidDataState {
  @Selector()
  getCurrentBidData(state: CurrentBidDataStateModel) {
    return state.currentBidData;
  }

  @Action(AddCurrentBidData)
  add(
    { patchState }: StateContext<CurrentBidDataStateModel>,
    { payload }: AddCurrentBidData
  ) {
    patchState({ currentBidData: payload });
  }

  @Action(RemoveCurrentBidData)
  remove({ patchState }: StateContext<CurrentBidDataStateModel>): void {
    patchState({ currentBidData: undefined });
  }
}
